import React, { useLayoutEffect } from "react"
import { useMap } from "react-leaflet"

const RecenterAutomaticallyMap = ({ centerLatLonMap, zoom = null }) => {
  const map = useMap()
  // Layout effect: position before the first paint, otherwise the map shows initialCenter for a frame
  useLayoutEffect(() => {
    if (!centerLatLonMap) return
    // animate:false — animated setView stranded the map mid-flight.
    map.whenReady(() => {
      map.setView(centerLatLonMap, zoom ?? map.getZoom(), { animate: false })
    })
  }, [centerLatLonMap, zoom, map])
  return null
}

export default RecenterAutomaticallyMap
